export enum RoamingTypeEnum {
    WORLD_COVERAGE = 'WORLD_COVERAGE',
    EU_INCLUDE_SWISS = 'EU_INCLUDE_SWISS',
    EU_WITHOUT_SWISS = 'EU_WITHOUT_SWISS',
    CALLS_SMS_ONLY = 'CALLS_SMS_ONLY',
    COVERAGE_NONE = 'COVERAGE_NONE',
}